import { IValveVar } from '../ValveVar'
import { EnergyValveControlMode } from './EnergyValveControlMode';
import { EnergyValveState } from './EnergyValveState';

export interface IBelimoEnergyValve extends IValveVar {

    setpointAbsoluteFlow: number;
    absoluteFlow: number;
    dimensionFlow: string;
    errorState: number;

    noCommunication: boolean;
    gearDisengaged: boolean;
    actuatorCannotMove: boolean;
    reverseFlow: boolean;
    flowSetpointNotReached: boolean;
    fFlowWithClosedValve: boolean;
    flowActualExceedsFlowNomina: boolean;
    flowMeasurementError: boolean;
    remoteTemperatureNotOK: boolean;
    flowbodyTemperatureNotOK: boolean;
    communicationToSensorInterrupted: boolean;
    freezeWarning: boolean;
    glycolDetected: boolean;
    powerSetpointNotReached: boolean;
    eVState: EnergyValveState;
    eVMode: EnergyValveControlMode;


}

export const schema = 'AutomationApps.Devices.Valves.BelimoEnergyValve';